/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import { labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /** Sets `margin`s on this component. */
  margin?: string | number;
  /** Anything you want to render with a `margin` wrapped around it. */
  children: React.ReactNode;
};

const Styles = labelStyles('Margin', {
  root: (props: Props) => ({
    margin: props.margin,
  }),
});

/**
 * Wraps any node with a `div` that is styled with the specified `margin`.
 *
 * For putting margins on things without needing to put the margins directly on the things.
 */
export const Margin = (props: Props) => (
  <div css={Styles.root(props)} data-zds>
    {props.children}
  </div>
);
